<div class="session-detail pt-4">
  <h2 class="session-info-title">Sentences</h2>
  @for (sentence of sentences; track sentence; let i = $index) {
    <div class="item-container">
      <div class="d-flex">
        <div class="sentence-number">{{ i + 1 }}</div>
        <div class="flex-fill">
          <h3 class="sentence-titles">Sentence</h3>
          <div
            class="sentence-text d-flex flex-xcontent-center"
            [class.moreThanOneItem]="sentences.length > 1"
          >
            <div class="flex-fill">
              <div class="sentence-item-text">
                {{ sentence.sentence }}
              </div>
            </div>
            <div class="pl-3">
              <ng-icon
                [name]="sentimentIcon(sentence.sentiment_context_value)?.icon"
                [style.color]="
                  sentimentIcon(sentence.sentiment_context_value)?.color
                "
                [matTooltip]="'Sentiment: ' + sentence.sentiment_context_value"
                matTooltipPosition="above"
                class="sentiment-icon"
                [attr.aria-label]="
                  'Sentiment value ' + sentence.sentiment_context_value
                "
              ></ng-icon>
            </div>
          </div>

          @if (showDetails) {
            <h3 class="sentence-titles">Sentiment Details</h3>
            @if (!detailsLoaded) {
              <div class="d-flex flex-col pb-3 pt-3">
                <mat-spinner
                  class="flex-item-center"
                  [diameter]="45"
                  color="primary"
                ></mat-spinner>
              </div>
            }
            @if (detailsLoaded) {
              <div>
                @if (!groupsDetails?.length) {
                  <p class="empty-state">There is no details</p>
                }
                @for (groupDetails of groupsDetails; track groupDetails) {
                  <div class="flex-xcontent-center flex-fill">
                    <div>
                      <div
                        class="sentence-text flex-it flex-xcontent-center"
                        [class.moreThanOneItem]="groupsDetails.length > 1"
                      >
                        <div class="sentence-item-text flex-fill">
                          {{ joinWords(groupDetails) }}
                        </div>
                        <div class="pl-3 flex-it">
                          @if (isIdiom(groupDetails)) {
                            <ng-icon
                              name="HeroBookOpen"
                              [matTooltip]="'Sentiment due to Idiom.'"
                              matTooltipPosition="above"
                              class="idiom-icon"
                              aria-label="Idiom sentiment source"
                            ></ng-icon>
                          }
                          <ng-icon
                            [name]="sentimentIcon(groupDetails.valence).icon"
                            [style.color]="
                              sentimentIcon(groupDetails.valence).color
                            "
                            [matTooltip]="'Sentiment: ' + groupDetails.valence"
                            matTooltipPosition="above"
                            class="sentiment-icon"
                            [attr.aria-label]="
                              'Sentiment value ' + groupDetails.valence
                            "
                          ></ng-icon>
                        </div>
                      </div>
                    </div>
                    <div class="pl-3"></div>
                  </div>
                }
              </div>
            }
          }

          @if (sentence.categories) {
            <h3 class="sentence-titles">Categories</h3>
            <div>
              @for (
                item of sentence.categories | parentHashTree: hashes : lookup;
                track item
              ) {
                <div
                  class="flex-it flex-row flex-content-start sentences-pill-container"
                >
                  <span
                    matTooltip="Category L1"
                    class="badge-pill categories-pill-l1"
                    >{{ item.name }}</span
                  >
                  @for (child of item.children; track child) {
                    <span
                      matTooltip="Category L2"
                      class="badge-pill categories-pill-l2"
                      >{{ child.name }}</span
                    >
                  }
                </div>
              }
            </div>
          }

          @if (!hasPredictionData(sentence)) {
            <h3 class="sentence-titles">Predictions</h3>
            <p class="empty-state">There is no predictions</p>
          } @else {
            <h3 class="sentence-titles">Predictions</h3>
            <div class="item d-flex flex-wrap sentences-pill-container">
              @for (topic of sentence?.topic; track topic) {
                @for (item of topic.predict; track item) {
                  <span
                    class="badge-pill topics sentence-predictions"
                    matTooltip="Topic"
                    matTooltipPosition="above"
                  >
                    <ng-icon
                      [name]="fieldIcon['topic']?.icon"
                      [style.color]="fieldIcon['white']?.color"
                      class="field-type-icon mr-2"
                      aria-label="Topic"
                    ></ng-icon>
                    {{ item }}
                  </span>
                }
              }

              @for (emotion of sentence?.emotion; track emotion) {
                @for (item of emotion.predict; track item) {
                  <span
                    class="badge-pill emotions sentence-predictions"
                    matTooltip="Emotion"
                    matTooltipPosition="above"
                  >
                    <ng-icon
                      [name]="fieldIcon['emotion']?.icon"
                      [style.color]="fieldIcon['white']?.color"
                      class="field-type-icon mr-2"
                      aria-label="Emotion"
                    ></ng-icon>
                    {{ item }}
                  </span>
                }
              }

              @for (fluff of sentence?.fluff; track fluff) {
                @for (item of fluff.predict; track item) {
                  <span
                    class="badge-pill fluff sentence-predictions"
                    matTooltip="Fluff Statement"
                    matTooltipPosition="above"
                  >
                    <ng-icon
                      [name]="fieldIcon['fluff']?.icon"
                      [style.color]="fieldIcon['white']?.color"
                      class="field-type-icon mr-2"
                      aria-label="Fluff Statement"
                    ></ng-icon>
                    {{ item }}
                  </span>
                }
              }

              @for (intent of sentence?.intent; track intent) {
                @for (item of intent.predict; track item) {
                  <span
                    class="badge-pill intents sentence-predictions"
                    matTooltip="Intent"
                    matTooltipPosition="above"
                  >
                    <ng-icon
                      [name]="fieldIcon['intent']?.icon"
                      [style.color]="fieldIcon['white']?.color"
                      class="field-type-icon mr-2"
                      aria-label="Intent"
                    ></ng-icon>
                    {{ item }}
                  </span>
                }
              }

              @for (effort of sentence?.effort; track effort) {
                @for (item of effort.predict; track item) {
                  <span
                    class="badge-pill effort sentence-predictions"
                    matTooltip="Effort Statement"
                    matTooltipPosition="above"
                  >
                    <ng-icon
                      [name]="fieldIcon['effort']?.icon"
                      [style.color]="fieldIcon['white']?.color"
                      class="field-type-icon mr-2"
                      aria-label="Effort Statement"
                    ></ng-icon>
                    {{ item }}
                  </span>
                }
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
